export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const GET_SUBSCRIPTION_BY_ID = 'GET_SUBSCRIPTION_BY_ID';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const DELETE_SUBSCRIPTION = 'DELETE_SUBSCRIPTION';
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
